module.exports = __webpack_public_path__ + "img/ico_arw_up_off.c040fbac.svg";